import * as React from 'react';

export interface IconProps {
  path: string;
  size?: string | number;
  className?: string;
  color?: string;
}

export const Icon: React.FC<IconProps> = ({
  path,
  size = 24,
  className,
  color = 'currentColor',
}) => {
  const sizeValue = typeof size === 'string' ? size : size.toString();

  return (
    <svg
      viewBox='0 0 24 24'
      width={sizeValue}
      height={sizeValue}
      className={className}
      fill={color}
    >
      <path d={path} />
    </svg>
  );
};
